import { PlatformProductCategory, UnitCode } from '~/graphql/graphql';

export function isUnitAllowedForCategory(
  category: PlatformProductCategory | string | null | undefined,
  unit: UnitCode | string
): boolean {
  return (
    category !== PlatformProductCategory.Specialty || unit === UnitCode.Pcs
  );
}

export function unitOptionsForCategory(
  category: PlatformProductCategory | string | null | undefined,
  options: string[],
  currentUnit?: string
): string[] {
  const allowed = options.filter((unit) =>
    isUnitAllowedForCategory(category, unit)
  );
  const hasDisallowedCurrentUnit =
    currentUnit && !isUnitAllowedForCategory(category, currentUnit);
  return hasDisallowedCurrentUnit && !allowed.includes(currentUnit)
    ? [currentUnit, ...allowed]
    : allowed;
}
